import { ObjetKForm, requiredRule, combineRules } from '@siclop/kstone-vue'

export class WireframeForm extends ObjetKForm {
  functionalityId?: number
  projectId?: number
  designSystemId: number = 1
  name: string = ''
  description: string = ''
  canvasWidth: number = 1920
  canvasHeight: number = 1080
  backgroundColor: string = '#FFFFFF'
  canvasDataJson: string = '[]'
  order: number = 0

  static validationRules = {
    designSystemId: combineRules(requiredRule('Le design system est obligatoire')),
    name: combineRules(requiredRule('Le nom est obligatoire'))
  }

  constructor(data?: Partial<WireframeForm>) {
    super(data)
    if (data) {
      this.functionalityId = data.functionalityId
      this.projectId = data.projectId
      this.designSystemId = data.designSystemId ?? 1
      this.name = data.name ?? ''
      this.description = data.description ?? ''
      this.canvasWidth = data.canvasWidth ?? 1920
      this.canvasHeight = data.canvasHeight ?? 1080
      this.backgroundColor = data.backgroundColor ?? '#FFFFFF'
      this.canvasDataJson = data.canvasDataJson ?? '[]'
      this.order = data.order ?? 0
    }
  }
}
